import React, { Component } from 'react'
// import MainMicrosoftOfficeExcel2010 from './main_microsoft_office_excel_2010'
import { Helmet } from 'react-helmet'
import DictsInfo from '../../components/dicts_info.jsx'
// import { Link } from 'react-router-dom';
// import GambarPointer1 from './img/pointer1.png'

// function refreshPage(){
//     setTimeout(()=>{
//       window.location.reload(false);
//     }, 500);
   
//   }


export default class CaraMenghapusMengcopyMemindahkanDataPadaMsOfficeExcel2010 extends Component {
  render() {
    return (
      <div>

      <Helmet>
        <title>Cara Menghapus Meng-copy Memindahkan Data Pada Microsoft Office Excel 2010</title>
        <meta name="description" content="belajar Microsoft Office Excel 2010, tutorial Microsoft Office Excel 2010, tutorial Microsoft Excel 2010 untuk pemula, berapa bagian Microsoft Excel"/>
      </Helmet>
      
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">

              {/* <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInBottom"> */}
              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >

              {/* <br/>
              <br/> */}
                  
                  
                <h1 style={{fontSize: '1.5rem'}} className="colorlib-heading">Cara Menghapus Meng-copy Memindahkan Data Pada Microsoft Office Excel 2010</h1>

                <div className="w3-container">
                    <h2>Cara menghapus data pada sel</h2>
                    <p>Untuk menghapus data pada sel caranya adalah:</p>
                    <div className= "w3-container" > 
                        <ol> 
                            <li>Klik pada sel yang ingin dihapus</li> 
                            <li>Lalu tekan tombol <b>Delete</b> atau tekan tombol <b>Backspace</b>.</li> 
                        </ol> 
                    </div>
                </div>
                <br/>

                <div className="w3-container">
                    <h2>Cara meng-copy data pada sel</h2>
                    <p>Untuk meng-copy data pada sel caranya adalah:</p>
                    <div className= "w3-container" > 
                        <ol> 
                            <li>Klik pada sel yang akan di copy.</li> 
                            <li>Selanjutnya tekan <b>Ctrl + C</b>.</li> 
                            <li>Lalu klik sel di mana data akan ditempatkan.</li> 
                            <li>Selanjutnya tekan <b>Ctrl + V</b>.</li> 
                            <li>Lalu tekan tombol <b>Enter</b>.</li>
                        </ol> 
                    </div>
                </div>
                <br/>

                <div className="w3-container">
                    <h2>Cara memindahkan data pada sel</h2>
                    <p>Untuk memindahkan data pada sel caranya adalah:</p>
                    <div className= "w3-container" > 
                        <ol> 
                        <li>Klik pada sel yang akan di pindahkan.</li> 
                        <li>Selanjutnya tekan <b>Ctrl + X</b>.</li> 
                        <li>Lalu klik sel di mana data akan ditempatkan.</li> 
                        <li>Selanjutnya tekan <b>Ctrl + V</b>.</li> 
                        <li>Lalu tekan tombol <b>Enter</b>.</li> 
                        </ol> 
                    </div>
                </div>

                
                

                <br/>
                <p><b>Semoga Bermanfaat..</b></p>
               
              </div>
              <DictsInfo/>
            </div>

            {/* <div className="row row-pt-md"></div> */}

          </div>
        </section>
        {/* <MainMicrosoftOfficeExcel2010/> */}
      </div>
    )
  }
}
